import {blurForm, focusForm} from './behaviors/inline-comment'
// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'
import {TemplateInstance} from '@github/template-parts'
import {remoteForm} from '@github/remote-form'

on('click', '.js-feed-post-comment-form-button', function ({currentTarget}) {
  insertForm(currentTarget)
})

on('click', '.feed-comment-paging-form-body', function ({currentTarget}) {
  const form = currentTarget.querySelector<HTMLFormElement>('.js-feed-post-comment-paging-form')!
  const formData = new FormData(form)
  const page = formData.get('page')
  const post = formData.get('feed_post_id')

  const pageInput = document.querySelector<HTMLInputElement>(`#feed-post-${post}-comment-page`)
  if (pageInput) pageInput.value = `${page}`
})

function insertForm(currentTarget: Element) {
  const commentContainer = currentTarget.closest<HTMLElement>('.js-feed-item-component')!
  const targetContainer = commentContainer.querySelector<HTMLElement>('.js-feed-post-comment-form-container')
  if (!targetContainer) return
  const postId = targetContainer.getAttribute('data-post-id')
  const template = document.querySelector<HTMLTemplateElement>('template.js-new-comment-template')
  if (postId && template) {
    targetContainer.textContent = ''
    targetContainer.appendChild(new TemplateInstance(template, {postId}))
  }

  focusForm(commentContainer)
}

remoteForm('.js-feed-post-comment-form', async function (form, wants) {
  await wants.text()
  blurForm(form)
  const container = form.closest('.js-feed-post-comment-form-container')!
  // eslint-disable-next-line github/no-d-none
  container.querySelector('.js-comment-form-error')?.classList.add('d-none')
})
